import React, { useContext, useEffect, useState } from 'react'

//context
import { OrgSettingsUserGroupsContext } from '@/context/OrgSettingsUserGroupsContext';

//interfaces
import { ITableColumn, ITableContent, ITableRows } from  '@/interfaces/simpleTable';
import { IUserWorkspaceData, WorkspaceSortByType } from  '@/interfaces/workspaces';
import { SortBy } from  '@/interfaces/toggle';

//components
import WorkspaceIconAndName from  '@/components/elements/orgSettings/tableCellItems/WorkspaceIconAndName';
import UserRolePermissions from  '@/components/elements/orgSettings/tableCellItems/buttons/userRolePermissions';
import { isOrganisationAdmin } from  '@/helpers/OrgSettings';



const UseUserGroupsWorkspacesTab = () => {  
    const {userGroupId, setWorkspacesSortToggle, workspacesSortToggle, getWorkspacesForGroup, isWorkspacesLoading, setIsWorkspacesLoading, workspacePaginationSettings, workspaceData, removeGroupFromWorkspace, notificationDetails, userGroupName} = useContext(OrgSettingsUserGroupsContext);

    const noDataMessage = "Usergroup has no workspaces yet";

    const columns: ITableColumn[] = [
        { title: "Workspace Name", isToggleButton: true, onSortAscendingClick: () => toggleSort(WorkspaceSortByType.WORKSPACE, SortBy.DESCENDING), onSortDescendingClick: () => toggleSort(WorkspaceSortByType.WORKSPACE, SortBy.ASCENDING) }, 
        { title: "Workspace Role", isToggleButton: true, onSortAscendingClick: () => toggleSort(WorkspaceSortByType.ROLE, SortBy.ASCENDING),  onSortDescendingClick: () => toggleSort(WorkspaceSortByType.ROLE, SortBy.DESCENDING)}
    ];
    const [tableContent, setTableContent] = useState<ITableContent>({rows: [], columns: columns});
    const [showSimpleTable, setShowSimpleTable] = useState<boolean>(false);
    const [showRemoveAccessModal, setShowRemoveAccessModal] = useState<boolean>(false);
    const [workspaceName, setWorkspaceName] = useState<string>("");
    const [workspaceId, setWorkspaceId] = useState<any>();

    useEffect(()=> {
        getWorkspacesForGroup();            
    }, []);

    useEffect(()=> {
        getWorkspacesForGroup();            
    }, [workspacesSortToggle, userGroupId]);

    useEffect(() => { 
        if (workspaceData === undefined) {
            setShowSimpleTable(true);
            setIsWorkspacesLoading(true);
        }
        let rows: ITableRows[] = [];
        workspaceData?.forEach((userWorkspace: IUserWorkspaceData) => {
            const row: ITableRows = {
                content: [
                    <WorkspaceIconAndName icon={userWorkspace.icon} workspaceName={userWorkspace.name} />,
                    <UserRolePermissions id={userGroupId} appId={userWorkspace.appId.toString()} permission={userWorkspace.permission} grantType={userWorkspace.grantType} />,
                ], 
                controls: !isOrganisationAdmin(userWorkspace.permission, userWorkspace.grantType) ? [{content:"Remove workspace access", onClick:() => onOpenModalClick(userWorkspace.appId, userWorkspace.name)}] : []
            };
            rows.push(row);
        });
 
        setTableContent({rows: rows, columns: columns});
        setIsWorkspacesLoading(false);
    }, [workspaceData]);

    function toggleSort(sortByType: WorkspaceSortByType, sortBy: SortBy) {
        setWorkspacesSortToggle([sortByType, sortBy]);
    }

    function onOpenModalClick(workspaceid: any, workspacename:string){
        setWorkspaceId(workspaceid);
        setWorkspaceName(workspacename);
        setShowRemoveAccessModal(true)
    }

    function setPage(page: number) {
        getWorkspacesForGroup(page)
    }
    
    function onRemoveAccessClick() {
        removeGroupFromWorkspace(workspaceId);
        setShowRemoveAccessModal(false);
    }

    return{noDataMessage, tableContent, isLoading: isWorkspacesLoading, paginationSettings: workspacePaginationSettings, showSimpleTable, showRemoveAccessModal, onRemoveAccessClick, setShowRemoveAccessModal, setPage, notificationDetails, workspaceName, userGroupName}
}

export default UseUserGroupsWorkspacesTab